import { useAccountEntitlements } from "@/entitlements/queries/useAccountEntitlements";

export const SURVEYS_ENTITLEMENT_KEY = "Surveys";

export function useHasSurveysEntitlement(): {
  loading: boolean;
  isError: boolean;
  hasEntitlement: boolean;
} {
  const { data, isLoading, isError } = useAccountEntitlements();

  return {
    loading: isLoading,
    isError,
    hasEntitlement:
      data?.account_access?.some(
        (access) => access.entitlement_key === SURVEYS_ENTITLEMENT_KEY,
      ) ?? false,
  };
}
